import { render, staticRenderFns } from "./NewProposalWizardHolder.vue?vue&type=template&id=5e39fc54&scoped=true"
import script from "./NewProposalWizardHolder.vue?vue&type=script&lang=js"
export * from "./NewProposalWizardHolder.vue?vue&type=script&lang=js"
import style0 from "./NewProposalWizardHolder.vue?vue&type=style&index=0&id=5e39fc54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e39fc54",
  null
  
)

/* custom blocks */
import block0 from "./NewProposalWizardHolder.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports